import { render, staticRenderFns } from "./WDExpandDetailCell.vue?vue&type=template&id=ffb6e408&"
import script from "./WDExpandDetailCell.vue?vue&type=script&lang=js&"
export * from "./WDExpandDetailCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports